import Vue from "vue";
import VueRouter from "vue-router";
import Router from "vue-router";
import firebase from "firebase/compat/app";

Vue.use(VueRouter);
const router = new Router({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      meta: {
        requiresAdmin: true,
      },
      component: () => import("@/views/pages/Verset/Verset.vue"),

    },
    {
      path: "/Verset",
      name: "Verset",
      meta: {
        requiresAdmin: true,
      },
      component: () => import("@/views/pages/Verset/Verset.vue"),
    },
    {
      path: "/VersetGroupe",
      name: "VersetGroupe",
      meta: {
        requiresAdmin: true,
      },
      component: () => import("@/views/pages/Verset/VersetGroupe.vue"),
    },
    {
      path: "/subscription",
      name: "Subscription",
      meta: {
        requiresAdmin: true,
      },
      component: () =>
        import("@/views/pages/Subscription/subscriptionList.vue"),
    },
    {
      path: "/subscriptionUsers",
      name: "subscriptionUsers",
      meta: {
        requiresAdmin: true,
      },
      component: () =>
        import("@/views/pages/Subscription/subscriptionUsers.vue"),
    },
    {
      path: "/QRCode",
      name: "QRCode",
      meta: {
        requiresAdmin: true,
      },
      component: () =>
        import("@/views/pages/Subscription/QRCode.vue"),
    },
    {
      path: "/EditVerset/:suratId/:versetId",
      name: "EditVerset",
      meta: {
        requiresAdmin: true,
      },
      component: () => import("@/views/pages/Verset/EditVerset.vue"),
    },
    {
      path: "/Surat",
      name: "Surat",
      meta: {
        requiresAdmin: true,
      },
      component: () => import("@/views/pages/Surat.vue"),
    },
    {
      path: "/EditActuality/:id",
      name: "EditActuality",
      meta: {
        requiresAdmin: true,
      },
      component: () => import("@/views/pages/Actuality/EditActuality.vue"),
    },
    {
      path: "/VisualiserActuality/:id",
      name: "VisualiserActuality",
      meta: {
        requiresAdmin: true,
      },
      component: () => import("@/views/pages/Actuality/VisualiserActuality.vue"),
    },
    {
      path: "/Actuality",
      name: "Actuality",
      meta: {
        requiresAdmin: true,
      },
      component: () => import("@/views/pages/Actuality/Actuality.vue"),
    },
    {
      path:"/Tag",
      name:"Tag",
      meta:{
        requiresAdmin:true
      },
      component:()=>import("@/views/pages/Tag/Tag.vue")
    },
    {
      path: "/complaint",
      name: "Complaint",
      meta: {
        requiresAdmin: true,
      },
      component: () => import("@/views/pages/Complaint/Complaint.vue"),
    },
    {
      path: "/faq",
      name: "Faq",
      meta: {
        requiresAdmin: true,
      },
      component: () => import("@/views/pages/Faq/faq.vue"),
    },
    {
      path: "/statistique",
      name: "Statistique",
      meta: {
        requiresAdmin: true,
      },
      component: () => import("@/views/pages/Statique/notification.vue"),
    },
    {
      path: "/Actuality/Categorie/:category/:id",
      name: "ActualityCategorie",
      meta: {
        requiresAdmin: true,
      },
      component: () => import("@/views/pages/Actuality/ActualityCategorie.vue"),
    },
    {
      path: "/Actuality/Categorie/:category/:categoryid/SerieDetail/:id",
      name: "SerieDetail",
      meta: {
        requiresAdmin: true,
      },
      component: () => import("@/views/pages/Actuality/SerieDetail.vue"),
    },
    {
      path: "/Recitateur",
      name: "Recitateur",
      meta: {
        requiresAdmin: true,
      },
      component: () => import("@/views/pages/Recitateur.vue"),
    },
    {
      path: "/EditRecitateur/:id",
      name: "EditRecitateur",
      meta: {
        requiresAdmin: true,
      },
      component: () => import("@/views/pages/EditRecitateur.vue"),
    },

    {
      path: "/VersetStartTimeSurat/:suratId/:recitateurId",
      name: "VersetStartTime",
      meta: {
        requiresAdmin: true,
      },
      component: () => import("@/views/pages/Verset/VersetStartTime.vue"),
    },
    {
      path: "/EditVersetStartTime/:versetId/:recitateurId",
      name: "EditVersetStartTime",
      meta: {
        requiresAdmin: true,
      },
      component: () => import("@/views/pages/Verset/EditVersetStartTime.vue"),
    },
    {
      path: "/SousTheme",
      name: "SousTheme",
      meta: {
        requiresAdmin: true,
      },
      component: () => import("@/views/pages/SousTheme/SousTheme.vue"),
    },
    {
      path: "/SousVersetList",
      name: "SousVersetList",
      meta: {
        requiresAdmin: true,
      },
      component: () => import("@/views/pages/SousVersetList.vue"),
    },
    {
      path: "/Admins",
      name: "Admins",
      meta: {
        requiresAdmin: true,
      },
      component: () => import("@/views/pages/users/Admins.vue"),
    },
    {
      path: "/User",
      name: "User",
      meta: {
        requiresAdmin: true,
      },
      component: () => import("@/views/pages/users/User.vue"),
    },
    {
      path: "/NewUser",
      name: "NewUser",
      meta: {
        requiresAdmin: true,
      },
      component: () => import("@/views/pages/users/NewUser.vue"),
    },

    {
      path: "/EditSousTheme:id",
      name: "EditSousTheme",
      meta: {
        requiresAdmin: true,
      },
      component: () => import("@/views/pages/SousTheme/EditSousTheme.vue"),
    },
    {
      path: "/Theme",
      name: "Theme",
      meta: {
        requiresAdmin: true,
      },
      component: () => import("@/views/pages/Theme/Theme.vue"),
    },
    {
      path: "/EditTheme:id",
      name: "EditTheme",
      meta: {
        requiresAdmin: true,
      },
      component: () => import("@/views/pages/Theme/EditTheme.vue"),
    },
    {
      path: "/Juzz",
      name: "Juzz",
      meta: {
        requiresAdmin: true,
      },
      component: () => import("@/views/pages/Juzz.vue"),
    },
    {
      path: "/Hizb",
      name: "Hizb",
      meta: {
        requiresAdmin: true,
      },
      component: () => import("@/views/pages/Hizb.vue"),
    },
    {
      path: "/login",
      name: "login",
      component: () => import("@/views/pages/Login.vue"),
      meta: {
        layout: "blank",
      },
    },
    {
      path: "/Duaa",
      name: "duaa",
      meta: {
        requiresAdmin: true,
      },
      component: () => import("@/views/pages/duaa/Duaa.vue"),
    },
    {
      path: "/EditDuaa/:id",
      name: "EditDuaa",
      meta: {
        requiresAdmin: true,
      },
      component: () => import("@/views/pages/duaa/EditDuaa.vue"),
    },
    {
      path: "/SousDuaa",
      name: "SousDuaa",
      meta: {
        requiresAdmin: true,
      },
      component: () => import("@/views/pages/SousDuaa/SousDuaa.vue"),
    },
    {
      path: "/EditSousDuaa/:id",
      name: "EditSousDuaa",
      meta: {
        requiresAdmin: true,
      },
      component: () => import("@/views/pages/SousDuaa/EditSousDuaa.vue"),
    },
    {
      path: "/Author",
      name: 'Author',
      meta: {
        requiresAdmin: true,
      },
      component: () => import("@/views/pages/Author/AuthorView.vue")
    },
    {
      path: "/EditAuthor/:id",
      name: 'EditAuthor',
      meta: {
        requiresAdmin: true,
      },
      component: () => import("@/views/pages/Author/EditAuthorView.vue")
    },
    {
      path: "/Expert",
      name: 'Expert',
      meta: {
        requiresAdmin: true,
      },
      component: () => import("@/views/pages/Expert/ExpertView.vue")
    },
    {
      path: "/EditExpert/:id",
      name: 'EditExpert',
      meta: {
        requiresAdmin: true,
      },
      component: () => import("@/views/pages/Expert/EditExpertView.vue")
    },
    {
      path: "/GeneralSetting",
      name: 'GeneralSettings',
      meta: {
        requiresAdmin: true,
      },
      component: () => import("@/views/pages/General-settings/GeneralSettingview.vue")
    },
    {
      path: "/Investigation",
      name: "Investigation",
      meta: {
        requiresAdmin: true,
      },
      component: () => import("@/views/pages/investigation/Investigation.vue")
    },
    {
      path: "/Personalise",
      name: "Personalise",
      meta: {
        requiresAdmin: true,
      },
      component: () => import("@/views/pages/Personalise/Personalise.vue")
    },
    {
      path: "/Podcast",
      name: "Podcast",
      meta: {
        requiresAdmin: true,
      },
      component: () => import("@/views/pages/Podcast/Podcast.vue")
    },
    {
      path: "/EditPodcast/:id",
      name: "EditPodcast",
      meta: {
        requiresAdmin: true,
      },
      component: () => import("@/views/pages/Podcast/EditPodcast.vue")
    },
    {
      path: "/notification",
      name: "notification",
      meta: {
        requiresAdmin: true,
      },
      component: () => import("@/views/pages/notification/notification.vue")
    },
    {
      path: "/Category",
      name: "Category",
      meta: {
        requiresAdmin: true,
      },
      component: () => import("@/views/pages/Category/Category.vue")
    },
    {
      path: "/SubCategory",
      name: "SubCategory",
      meta: {
        requiresAdmin: true,
      },
      component: () => import("@/views/pages/SubCategory/SubCategory.vue")
    },
    {
      path: "/ComingSoon",
      name: "ComingSoon",
      meta: {
        requiresAdmin: true,
      },
      component: () => import("@/views/pages/ComingSoon/ComingSoon.vue")
    }
    /* {
      path: "/cards",
      name: "cards",
      component: () => import("@/views/cards/Card.vue"),
    },
    {
      path: "/simple-table",
      name: "simple-table",
      component: () => import("@/views/simple-table/SimpleTable.vue"),
    },
    {
      path: "/form-layouts",
      name: "form-layouts",
      component: () => import("@/views/form-layouts/FormLayouts.vue"),
    },
    {
      path: "/pages/account-settings",
      name: "pages-account-settings",
      component: () =>
        import("@/views/pages/account-settings/AccountSettings.vue"),
    },*/

    /*{
      path: "/pages/register",
      name: "pages-register",
      component: () => import("@/views/pages/Register.vue"),
      meta: {
        layout: "blank",
      },
    },*/
    /* {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/Error.vue'),
    meta: {
      layout: 'blank',
    },
  },
  {
    path: '*',
    redirect: 'error-404',
  },*/
  ],
});

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAdmin);
  if (requiresAuth && !(await firebase.getCurrentUser())) {
    next("login");
  } else {
    next();
  }
});
export default router;
